import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-welcome-page',
  templateUrl: './welcome-page.component.html',
  styleUrl: './welcome-page.component.scss',
})
export class WelcomePageComponent implements OnInit
 {
  constructor(private logger: NGXLogger, private router: Router){}

  ngOnInit(): void {

    if (sessionStorage.getItem('token') !== null && sessionStorage.getItem('token') !== undefined) {
      this.router.navigate(['home']);
    }

  }

  autenticazione(loginLevelSelected: number): void {
    if (loginLevelSelected == 3) {
      this.logger.info(
        "(AUTHENTICATOR-LOGIN) 2 - L'Utente ha selezionato la modalità di accesso SPID"
      );
      this.router.navigate(['/authenticate']);
    } else if (loginLevelSelected == 2) {
      this.logger.info(
        "(AUTHENTICATOR-LOGIN) 2 - L'Utente ha selezionato la modalità di accesso LDAP"
      );
      sessionStorage.setItem('loginLevel', 'ldap');
      this.router.navigate(['/login-form']);
    } else if (loginLevelSelected == 1) {
      this.logger.info(
        "(AUTHENTICATOR-LOGIN) 2 - L'Utente ha selezionato la modalità di accesso con Email e Pasword"
      );
      sessionStorage.setItem('loginLevel', 'normal');
      this.router.navigate(['/login-form']);
    }
  }
}
